<template>
  <div class="shop">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h3 class="text-center display-1 py-6">Browse Inventory</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" xl="8" offset-xl="2">
          <v-row>
            <v-col cols="12">
              <search-bar />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" lg="3">
              <v-card>
                <v-card-text>sidebar</v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12" lg="9" class="pt-0">
              <inventory-grid />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import InventoryGrid from "@/components/InventoryGrid.vue";
import SearchBar from "@/components/SearchBar.vue";
export default {
  name: "hshopome",
  components: { InventoryGrid, SearchBar }
};
</script>
